export default __webpack_public_path__ + "static/media/call.ac3b92bd.svg";